<template >
    <header>
      <h2 v-translate data-po-exclude="true">{{ title }}</h2>
    </header>
</template>

<script>
  /**
  * Header to show the title of the page.
  */
  export default {
    name: 'Header',
    data () {
      return {}
    },
    props: {
      /**
      * String - title to be displayed in this component. Passed down from parent
      */
      'title': {
        type: String
      }
    }
  }
</script>

<style scoped></style>
